import React from 'react'
import { Entity } from 'ts-lenses'
import { any, async, fromJSX, Updater, Widget } from 'widgets-for-react'
import { State } from '../../cmsPage.widget'
import { modernBlocksWidget } from '../../modernBlocks/modernBlocks.widget'
import { NewsletterPageLayout } from './newsletter.layout'
import { NewsletterPageState, updaters } from './newsletter.state'

export const newsletterPageWidget = (state: State): Widget<Updater<State>> => {
  let pageState = state.newsletterPageState

  return any<Updater<State>>([
    pageState.validator.widget()
      .map<Updater<NewsletterPageState>>(u => s => Entity(s)
        .set("validator", ov => u(ov))
        .set("validationResults", _ => u(s.validator).evaluateResult())
        .commit())
      .map<Updater<State>>(u => s => Entity(s).set("newsletterPageState", os => u(os)).commit()),

    async<{}>(pageState.submitResult)
      .map<Updater<NewsletterPageState>>(u => os => Entity(os).set("submitResult", osr => u(osr)).commit())
      .map<Updater<State>>(u => s => Entity(s).set("newsletterPageState", os => u(os)).commit()),

    fromJSX<Updater<NewsletterPageState>>((setState) => {
      return <NewsletterPageLayout.Wrapper>
        <NewsletterPageLayout.Inner
          text={'intro text'}
          title={"title"}
          state={state}
          blocks={
            modernBlocksWidget(
              state.rootModernBlocksState.modernBlocks.blocks,
              _ => { },
              state
            ).run(_ => _)
          }
        >
          <NewsletterPageLayout.Form
            state={pageState}
            validateField={field => updaters.ValidateForm(field, setState)}
            updateInput={(field, value, validate) => updaters.UpdateForm(field, value, setState, validate)}
            submitForm={(r) => updaters.SubmitForm(setState, r)}
            isDisabled={field => pageState.submitResult.kind === "loading"}
          />
        </NewsletterPageLayout.Inner>
      </NewsletterPageLayout.Wrapper>
    })
      .map<Updater<State>>(u => s0 => {
        const s1 = u(s0.newsletterPageState)
        const newState = { ...s0, newsletterPageState: s1 }

        return newState
      }),
    // fromJSX<Updater<State>>(setState =>
    //   modernBlocksWidget(
    //     state.rootModernBlocksState.modernBlocks.blocks,
    //     setState,
    //     state
    //   ).run(_ => _)
    // )
  ])
}
